import { createFileRoute } from "@tanstack/react-router";

import { VaultTransfer } from "../-components/VaultTransfer";

export const Route = createFileRoute("/_authenticated/trade/send/vault-transfer")({
  component: VaultTransfer,
  context: () => ({ permissions: "trade.send" }),
});
